export default "__VITE_ASSET__CjHub5qt__"